/*
 * useDeviceControls — the selected edge's device speed limits, and the writes
 * that change them (cloud-anchor/pkg/api/devicecontrols.go).
 *
 * One hook for the Device Speed Limits screen and the device drawer, so both
 * read and write the same way (useEdgeWrite).
 */
import useEdgeFeature, { FEATURE_PRESENT } from "./useEdgeFeature";
import useEdgeWrite from "./useEdgeWrite";

export default function useDeviceControls(nodeId) {
  const { state, payload, refresh } = useEdgeFeature(nodeId, "/devices/controls");
  const { busy, error, send } = useEdgeWrite(nodeId, refresh);

  return {
    state,
    view: state === FEATURE_PRESENT ? payload : null,
    busy,
    error,
    refresh,
    saveProfile: (profile) => send("PUT", "/devices/controls/profile", profile),
    deleteProfile: (id) => send("DELETE", `/devices/controls/profile?id=${encodeURIComponent(id)}`),
    assign: (mac, profile) => send("PUT", "/devices/controls/device", { mac, profile }),
    setNewDevices: (profile) => send("PUT", "/devices/controls/new-devices", { profile }),
  };
}
